// @flow

import { type Feature, type FeatureName } from '@tectonics/prs/feature';
import { type PrsSupport } from './types';

export function getSafeSupportedFeatureByName(featureName: FeatureName, support: PrsSupport): Feature {
  const feature = support.features.find(feature => feature.name === featureName);
  if (!feature)
    throw new Error(`getSafeSupportedFeatureByName - there is no support for feature "${featureName}"`);
  return feature;
}
